import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Hook to detect and apply language from URL parameter
 * Usage: Add ?lang=es or ?lang=en to any URL
 */
export const useLanguageFromURL = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Read URL parameters directly from window.location
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get("lang");

    if (langParam) {
      const supportedLanguages = ["es", "en"];
      const language = langParam.toLowerCase();

      if (supportedLanguages.includes(language)) {
        console.log(`[Language] Setting language from URL param: ${language}`);
        i18n.changeLanguage(language);

        // Optional: Store in localStorage for persistence
        localStorage.setItem("userLanguage", language);
      } else {
        console.warn(`[Language] Unsupported language in URL: ${langParam}`);
      }
    } else {
      // Check if there's a stored language preference
      const storedLanguage = localStorage.getItem("userLanguage");
      if (storedLanguage && i18n.language !== storedLanguage) {
        console.log(`[Language] Restoring stored language: ${storedLanguage}`);
        i18n.changeLanguage(storedLanguage);
      }
    }
  }, [i18n]);

  return { currentLanguage: i18n.language };
};
